import { RootReducer } from "../../reducers";
import { KeycloakUser } from "./types";

export const userSelector = (state: RootReducer): KeycloakUser | null =>
  state.auth.user;
